export default (({
  brandFooter = '',
  form: {
    themeColor = ''
  } = {}
}) => {
  document.querySelector('.questionnaire-header').style.backgroundColor = themeColor; // Set footer

  document.querySelector('.questionnaire-footer').innerHTML = brandFooter;
});